import axiosInstance from '@/utils/axiosInstance';

export default async function getClientApplication() {
  return (
    await axiosInstance.get<Application>('/client/application', {
      headers: {
        Accept: 'application/vnd.4finance.web.v1.hal+json',
        'Content-Type': 'application/vnd.4finance.web.v1.hal+json',
      },
    })
  ).data;
}

export type Application = {
  expired: boolean;
  confirmed: boolean;
  status: string;
  resolution: string;
  resolutionDetail: string;
  resolutionMessage: string;
  proposal?: {
    amount: number;
    term: number;
  };
  riskEvaluationStarted: boolean;
};
